import { getUUID } from '../helpers/commonHelper';
import { defaultGeoFeatureProperties } from '../constants/constants';
import { parseLineFeatureMetadata } from '../helpers/trailHelper';
import { getLines } from './collectionHelper';

export const parseFeatureMetadata = (feature) => {
    switch (true) {
        case feature.geometry.type.indexOf('Line') === 0:
            return {
                ...parseLineFeatureMetadata(feature),
            };
        case feature.geometry.type === 'Point':
            return {
                ...parsePointFeatureMetadata(feature),
            };
        default:
            return feature.properties;
    }
};

export const parsePointFeatureMetadata = (feature) => {
    // The sign of new trail
    const metadata = feature.properties;
    if (metadata.pictogram || metadata.published) {
        return metadata;
    }
    let tempName = metadata.name ? metadata.name : 'Raskrsnica';
    if (tempName.substr(0, 13).toLocaleLowerCase() === 'skretanje za ') {
        tempName = tempName.substr(10);
    }
    metadata.name = tempName;
    metadata.pictogram = metadata.pictogramDrawn;
    let tempDescArray = '',
        tempDesc = '',
        tempPictogram = '';
    if (metadata.desc !== undefined && metadata.desc.indexOf('#') > -1) {
        tempDescArray = metadata.desc
            .replace('#\n\n', '#\n')
            .replace('#\n\n', '#\n')
            .replace('#\n', '#')
            .replace('#\n', '#')
            .split('#');
        tempDesc = tempDescArray[2];
        tempPictogram = tempDescArray[1];
        delete metadata.desc;
    } else if (metadata.cmt !== undefined && metadata.cmt.indexOf('#') > -1) {
        tempDescArray = metadata.cmt
            .replace('#\n\n', '#\n')
            .replace('#\n\n', '#\n')
            .replace('#\n', '#')
            .replace('#\n', '#')
            .split('#');
        tempDesc = tempDescArray[2];
        tempPictogram = tempDescArray[1];
        delete metadata.cmt;
    } else if (metadata.desc !== undefined) {
        tempDesc = metadata.desc;
        tempPictogram =
            metadata.pictogram !== undefined ? metadata.pictogram : '90';
    } else {
        tempDesc = '';
        tempPictogram =
            metadata.pictogram !== undefined ? metadata.pictogram : '90';
    }
    metadata.desc = tempDesc;
    metadata.symbol = metadata.symbol || 'CROSSROAD';
    metadata.id = getUUID();
    metadata.desc = tempDesc;
    metadata.pictogram = tempPictogram;
    return {
        ...defaultGeoFeatureProperties.Point,
        ...metadata,
    };
};

export const enrichPoint = (point, collection) => {
    if (!point.properties.elevationProfile || !point.properties.parent) {
        return { ...point };
    }
    const { id, index } = point.properties.parent;
    const lines = getLines(collection);
    const line = lines.find(
        (l) => l.properties.id === id,
    );
    if (!line) {
        return { ...point };
    }
    const { richLine } = line.properties;
    const { remain, elevGain, elevLoss } = richLine[index];
    return {
        ...point,
        properties: {
            ...point.properties,
            elevGain,
            elevLoss,
            remain,
        },
    };
};

export const wpIsPlace = (point) => {
    const { symbol } = point.properties;
    if (!symbol) {
        return false;
    }
    return symbol === 'CITY' || symbol === 'PLACE' || symbol === 'VILLAGE';
};

export const wpIsOrienteering = (point) => {
    const { symbol } = point.properties;
    if (!symbol) {
        return false;
    }
    return (
        symbol === 'CROSSROAD' ||
        symbol === 'PASS' ||
        symbol === 'RIVER' ||
        symbol === 'SUMMIT' ||
        symbol === 'START' ||
        symbol === 'END'
    );
};

export const wpIsAmenities = (point) => {
    const { symbol } = point.properties;
    if (!symbol) {
        return false;
    }
    return (
        symbol === 'FOOD' ||
        symbol === 'SLEEP' ||
        symbol === 'PHOTO' ||
        symbol === 'WATER'
    );
};

export const wpIsWarning = (point) => {
    const { symbol } = point.properties;
    if (!symbol) {
        return false;
    }
    return symbol === 'DANGER' || symbol === 'MINES';
};
